import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CSVLink } from 'react-csv';

function AllInvoiceReport() {
  const [invoices, setInvoices] = useState([]);
  const [search, setSearch] = useState('');
  const [filteredInvoices, setFilteredInvoices] = useState([]);

  useEffect(() => {
    // Fetch all invoices from the API
    axios
      .get('https://serveralgama.mylksystems.com/sales/getAllBills')
      .then((res) => {
        setInvoices(res.data);
        setFilteredInvoices(res.data); // Initialize filtered invoices
      })
      .catch((error) => {
        console.error('Error fetching invoices:', error);
      });
  }, []);

  useEffect(() => {
    // Filter invoices based on search query
    if (search === '') {
      setFilteredInvoices(invoices);
    } else {
      const filtered = invoices.filter((invoice) =>
        invoice.inv_no.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredInvoices(filtered);
    }
  }, [search, invoices]);

  // Function to convert status (1 => Active, 0 => Deleted)
  const formatStatus = (status) => {
    return status === 1 ? 'Active' : 'Deleted';
  };

  return (
    <div>
      <h2>All Invoice Report</h2>

      {/* Search bar */}
      <input
        type="text"
        placeholder="Search by Invoice No."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{
          padding: '10px',
          marginBottom: '20px',
          width: '300px',
          borderRadius: '5px',
        }}
      />
       {/* CSV Download Button */}
       <CSVLink
        data={filteredInvoices}
        headers={[
          { label: 'Invoice No.', key: 'inv_no' },
          { label: 'Username', key: 'username' },
          { label: 'Item Name', key: 'item_name' },
          { label: 'Unit Price', key: 'unitprice' },
          { label: 'Quantity', key: 'qty' },
          { label: 'Total', key: 'total' },
          { label: 'Creation Date', key: 'creation_date' },
          { label: 'Status', key: 'status' },
        ]}
        filename={'invoice_report.csv'}
        style={{
          padding: '10px 20px',
          backgroundColor: '#000000',
          textDecoration: 'none',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          marginTop: '20px',
          marginLeft : 20
        }}
      >
        Download CSV
      </CSVLink>

      {/* Table to display invoices */}
      <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Invoice No.</th>
            <th>Username</th>
            <th>Item Name</th>
            <th>Unit Price</th>
            <th>Quantity</th>
            <th>Total</th>
            <th>Creation Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredInvoices.map((invoice) => (
            <tr key={invoice.invdetails_key}>
              <td>{invoice.inv_no}</td>
              <td>{invoice.username}</td>
              <td>{invoice.item_name}</td>
              <td>{invoice.unitprice}</td>
              <td>{invoice.qty}</td>
              <td>{invoice.total}</td>
              <td>{new Date(invoice.creation_date).toLocaleString()}</td>
              <td>{formatStatus(invoice.status)}</td>
            </tr>
          ))}
        </tbody>
      </table>

     
    </div>
  );
}

export default AllInvoiceReport;
